import { AxiosInstance } from "axios"
import { MerchantPosDevice, ZReport, ZReportDetails } from "./zReportsTypes"
import { DateType } from "../../../../../shared/components/filters/selectDateTypeFilter/SelectDateTypeFilter"

export enum AccountingZReportsQuery {
    Z_REPORTS_LIST = "z-reports-list-for-merchant",
    MERCHANT_POS_DEVICES = "devices-for-merchants",
}

type FetchZReportsParams = Readonly<{
    merchantId: number
    startDate: string
    endDate: string
    dateType: DateType
}>

export type FetchZReportsResponse = Readonly<{
    reportDetails: ZReportDetails
    zReports: Array<ZReport>
}>

export async function fetchZReports(
    params: FetchZReportsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchZReportsResponse> {
    const { merchantId, ...rest } = params

    const url = `/merchants/${merchantId}/accounting/zReports`

    const response = await axios.get(url, {
        params: rest,
        signal,
    })

    return response.data
}
